import _ from 'lodash';
import internalStore from '../@internalStore';

const MAINTENANCE_STATUS = 503;

const {
  appConfig: {
    actions: { startMaintenanceMode },
  },
} = internalStore;

const maintenanceMiddleware = store => next => action => {
  if (action.axios) {
    const status = _.get(action, 'payload.status');
    if (_.isNumber(status) && status === MAINTENANCE_STATUS) {
      store.dispatch(startMaintenanceMode());
    }
  }

  if (action.error) {
    const status = _.get(action, 'payload.http_status') || _.get(action, 'payload.status');
    if (_.isNumber(status) && status === MAINTENANCE_STATUS) {
      store.dispatch(startMaintenanceMode());
    }
  }

  return next(action);
};

export default maintenanceMiddleware;
